import React from "react";
import EditModal from "../../UI/EditModal";

export default function index() {
  return (
    <EditModal wrapperId="popupModal" headerText="Edit Medications">
      <div>Hello World</div>
    </EditModal>
  );
}
